import styled from 'styled-components'

export { BannerDiv }

const BannerDiv = styled.img`
    width: 100vw;
    height: 23rem;
`